// eslint-disable-next-line import/prefer-default-export
export const API_BASE_URL = process.env.REACT_APP_URL || 'https://tenant.stage.lobibox.com/api/v1/';
